var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClusterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .1;\n      }\n\n      .cls-2 {\n        fill: #b3b3b3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 16.88,
    ry: 16.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p_890.7383008418648",
    className: "cls-2",
    d: "M19.62,25.6c-.83,1.44-2.68,1.94-4.13,1.11-1.44-.83-1.94-2.68-1.11-4.13,.83-1.44,2.68-1.94,4.13-1.11,1.44,.83,1.94,2.68,1.11,4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p_903.4196827488582",
    className: "cls-2",
    d: "M23.71,18.51c-.83,1.44-2.68,1.94-4.13,1.11-1.44-.83-1.94-2.68-1.11-4.13s2.68-1.94,4.13-1.11,1.94,2.68,1.11,4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p_886.0965929088128",
    className: "cls-2",
    d: "M15.52,18.51c-.83,1.44-2.68,1.94-4.13,1.11s-1.94-2.68-1.11-4.13c.83-1.44,2.68-1.94,4.13-1.11,1.44,.83,1.94,2.68,1.11,4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p_898.7779748158063",
    className: "cls-2",
    d: "M19.62,11.42c-.83,1.44-2.68,1.94-4.13,1.11s-1.94-2.68-1.11-4.13,2.68-1.94,4.13-1.11,1.94,2.68,1.11,4.13Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterIcon);
export default __webpack_public_path__ + "static/media/cluster-icon.fbf1f8784d7f1522939d3b74b19f47fc.svg";
export { ForwardRef as ReactComponent };